import { authenticatedPatch } from '../../../../../api/utils/request';

export default async function saveCancelAppointment(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la cita.');
    const url = '/appointment-management/cancel-appointment';
    return await authenticatedPatch(url, onFail, saveData);
}
